import { CHANGE_TOKEN } from "../actions/token";

export default function token(state = null, action) {
  switch (action.type) {
    case CHANGE_TOKEN:
      return action.token;

    default:
      return state;
  }
}
